import { useEffect, useState } from 'react'

const usePersistedState = (key: string, initialState: any) => {
  const [state, setState] = useState(initialState)

  useEffect(() => {
    const savedState = localStorage.getItem(key)
    if (savedState !== null) setState(JSON.parse(savedState))
  }, [key])

  useEffect(() => {
    localStorage.setItem(key, JSON.stringify(state))
  }, [key, state])

  return [state, setState]
}

export default usePersistedState
